import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import NotificationModel from '@/models/notification.model';
import ConversationContactModel from '@/models/crm/conversation-contact.model';
import ContactModel from '@/models/crm/contact.model';
import ConversationModel from '@/models/crm/conversation.model';
import { ICreateConversation } from '@/interfaces/crm/create-conversation.interface';
import UserContactInfo from '@/models/crm/user-contact-info.model';
import ClientModel from '@/models/crm/client.model';

Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: 'geovendas',
  storage: localStorage,
  reducer: (state: State) => ({
    userContactInfo: state.userContactInfo,
    contactNumber: state.contactNumber,
    createConversationPayload: state.createConversationPayload,
    activeClient: state.activeClient,
  }),
});

class State {
  notifications: NotificationModel[] = [];

  contactNumber: string | null = null;

  clientId: string | null = null;

  activeClient: ClientModel | null = null;

  createConversationPayload: string | null = null;

  userContactInfo: UserContactInfo | null = null;

  createConversation: { waContact?: ConversationContactModel; contact?: ContactModel } = {
    waContact: undefined,
    contact: undefined,
  };

  openConversation: ConversationModel | null = null;
}

export default new Vuex.Store({
  state: new State(),
  mutations: {
    addNotification: (state, payload: NotificationModel, distinct = true) => {
      if (distinct) {
        state.notifications = state.notifications.filter((item) => item.text !== payload.text);
      }

      state.notifications = [...state.notifications, payload];
    },
    createConversation: (state, payload: ICreateConversation) => {
      state.createConversation = payload;
    },
    openConversation: (state, payload: ConversationModel) => {
      state.openConversation = payload;
    },

    activeClient: (state, payload: ClientModel) => {
      state.activeClient = payload;
    },
    setContactNumber(state, contactNumber) {
      state.contactNumber = contactNumber;
    },
    setClientId(state, clientId) {
      state.clientId = clientId;
    },
    setCreateConversationPayload(state, payload) {
      state.createConversationPayload = payload;
    },
    setUserContactInfo(state, userContactInfo) {
      state.userContactInfo = userContactInfo;
    },
  },
  getters: {
    notifications: (state) => state.notifications.filter((item) => item.active),
    getContactNumber: (state) => state.contactNumber,
    getConversationPayload: (state) => state.createConversationPayload,
    getClientId: (state) => state.clientId,
    getActiveClient: (state) => state.activeClient,
    getUserInfo: (state) => state.userContactInfo,
  },
  plugins: [vuexPersist.plugin],
});
